<div class="sh-page-template__main__wrapper">
  <div class="sh-page-template__main__content">
    <div class="sh-template-stack">
      <sh-page-header class="sh-template-stack__item" [title]="'components.saved-queries.overview.title' | translate"></sh-page-header>

      @if ((savedQueries$ | async)?.paginationInfo; as paginationInfo) {
        <digihaven-table-header
          class="sh-template-stack__item"
          [title]="'components.saved-queries.overview.results' | translate: { items: paginationInfo.totalNumberOfResults }"
        ></digihaven-table-header>
      }
      <div class="sh-template-stack__item">
        <div class="sh-card-table-wrapper">
          <table class="sh-card-table">
            <thead class="sh-card-table__header--context-actions">
              <tr>
                <th scope="col">{{ 'components.saved-queries.overview.columns.name' | translate }}</th>
                <th scope="col" class="sh-card-table__col--small">{{ 'components.saved-queries.overview.columns.actions' | translate }}</th>
              </tr>
            </thead>
            <tbody>
              @if (loading$ | async) {
                <tr>
                  <td [colSpan]="COLUMN_COUNT">{{ 'ui.loading' | translate }}</td>
                </tr>
              }

              @if (!(loading$ | async) && !(error$ | async) && (savedQueries$ | async)?.results.length === 0) {
                <tr>
                  <td [colSpan]="COLUMN_COUNT">{{ 'components.saved-queries.overview.messages.empty-list' | translate }}</td>
                </tr>
              }

              @if (error$ | async) {
                <tr class="sh-card-table__row--error">
                  <td [colSpan]="COLUMN_COUNT">{{ 'components.saved-queries.overview.messages.failed-to-fetch' | translate }}</td>
                </tr>
              }

              @if (!(loading$ | async) && !(error$ | async) && (savedQueries$ | async)?.results.length > 0) {
                @for (savedQuery of (savedQueries$ | async)?.results; track trackById(i, savedQuery); let i = $index) {
                  <tr>
                    <th scope="row" [id]="savedQuery.Id">{{ savedQuery.Name }}</th>
                    <td>
                      @if ((actionItems$ | async); as actionItems;) {
                        @if (actionItems[i]; as actionItem;) {
                          <sh-action-item [item]="actionItem"></sh-action-item>
                        }
                      }
                    </td>
                  </tr>
                }
              }
            </tbody>
          </table>
        </div>
      </div>
      <sh-pagination
        class="sh-template-stack__item"
        [paginationInfo]="(savedQueries$ | async)?.paginationInfo"
        [previousPageMsg]="'components.pagination.previous' | translate"
        [nextPageMsg]="'components.pagination.next' | translate"
        [perPageMsg]="'components.pagination.per-page' | translate"
        (paginationInfoChanged)="updatePagination($event)"
      ></sh-pagination>
    </div>
  </div>
</div>
